import { actions as appActions } from '../features/App/reducer'
import { onIsLoading } from './onLoading'
import { clientLogger } from './observability'

export const onError = (message: string) => {
  clientLogger.warn('ui.error_alert', { message })
  window.store.dispatch(
    appActions.onAlert({
      severity: 'error',
      message,
    })
  )
  onIsLoading(false)
}
